import React, { useState } from 'react';
import { IoSearch, IoPeopleOutline } from 'react-icons/io5';
import CommonLayout from '../../layouts/CommonLayout';
import MeetingSearchContainer from '../../containers/MeetingSearchContainer';
import { searchMeetings } from '../../../api/MeetingApi';
import useAuthStore from "../../../store/authStore";
import { AlertModal } from '../../layouts/AlertModal'; // AlertModal import

const SearchPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [recruitingOnly, setRecruitingOnly] = useState(true);
  const [hasSearched, setHasSearched] = useState(false);

  const { member } = useAuthStore();

  // 모달 상태 관리
  const [alertState, setAlertState] = useState({ isVisible: false, message: '', callback: null });

  const getErrorMessage = (error) => {
    if (error.response && error.response.data && error.response.data.message) {
      return error.response.data.message;
    }
    return '오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;

    try {
      setHasSearched(true);
      const response = await searchMeetings(member.latitude, member.longitude, searchQuery, recruitingOnly);
      setSearchResults(response.meetingSearchDtoList || []);
    } catch (error) {
      console.error('검색 실패:', error);
      setAlertState({ isVisible: true, message: getErrorMessage(error) });
      setSearchResults([]);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const renderSearchResults = () => {
    if (!hasSearched) {
      return (
          <div className="text-center py-16">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <IoSearch size={40} className="text-gray-400" />
            </div>
            <p className="text-gray-500">검색어를 입력해주세요</p>
          </div>
      );
    }

    if (!searchResults || searchResults.length === 0) {
      return (
          <div className="text-center py-16">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <IoPeopleOutline size={40} className="text-gray-400" />
            </div>
            <p className="text-gray-500">검색 결과가 없습니다</p>
          </div>
      );
    }

    return (
        <div className="bg-white rounded-lg">
          {searchResults.map((meeting) => (
              <MeetingSearchContainer key={meeting.meetingId} meeting={meeting} />
          ))}
        </div>
    );
  };

  return (
      <CommonLayout title="모임 검색">
        <AlertModal
            isVisible={alertState.isVisible}
            message={alertState.message}
            callback={alertState.callback}
            onClose={() => setAlertState({ isVisible: false, message: '', callback: null })}
        />
        {/* 검색 영역 */}
        <div className="p-4 bg-white border-b border-gray-200">
          <div className="max-w-lg mx-auto space-y-4">
            {/* 검색 입력창과 버튼 */}
            <div className="flex gap-2">
              <div className="flex-1 relative">
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="모임 제목이나 장소를 검색해보세요"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                />
              </div>
              <button
                  onClick={handleSearch}
                  disabled={!searchQuery.trim()}
                  className="px-6 py-3 bg-amber-500 text-white rounded-lg active:bg-amber-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
              >
                검색
              </button>
            </div>

            {/* 모집 중인 모임만 검색 체크박스 */}
            <div className="flex items-center">
              <input
                  type="checkbox"
                  id="recruitingOnly"
                  checked={recruitingOnly}
                  onChange={(e) => setRecruitingOnly(e.target.checked)}
                  className="mr-2 w-4 h-4 text-amber-600 bg-gray-100 border-gray-300 rounded focus:ring-amber-500"
              />
              <label htmlFor="recruitingOnly" className="text-sm text-gray-700">
                모집 중인 모임만 검색
              </label>
            </div>
          </div>
        </div>

        {/* 검색 결과 영역 */}
        <div className="p-4">
          <div className="max-w-lg mx-auto">
            {renderSearchResults()}
          </div>
        </div>
      </CommonLayout>
  );
};

export default SearchPage;
